export default __webpack_public_path__ + "static/media/05-02.a115243b.mp4";